import { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { removeLocalStorage } from '../../../helpers/LocalStorage';
import * as auth from "../_redux/authRedux";
import { cancelPendingCallbackSession } from "../_redux/pendingCallbackSession";
import { clearCache } from "../../../services/reactQuery";
import { resetSegmentIdentity } from "../../../services/tracking/segmentIdentity";
import { POST_LOGIN_REDIRECT_KEY } from "../../../constants/postLoginRedirect";

class Logout extends Component {
  componentDidMount() {
    cancelPendingCallbackSession();
    this.props.logoutRequested();

    sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

    try {
      resetSegmentIdentity();
    } catch (error) {
    }

    removeLocalStorage('group');
    removeLocalStorage('oab_monitoring_filter_selected');
    clearCache()
  }

  render() {
    const { hasAuthToken } = this.props;
    return hasAuthToken ? (
      <LayoutSplashScreen />
    ) : (
      <Redirect to="/auth/login" />
    );
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  { logoutRequested: auth.actions.logoutRequested }
)(Logout);
